import PropTypes from 'prop-types';

const filterButtonValue = PropTypes.oneOfType([
	PropTypes.string,
	PropTypes.bool,
	PropTypes.number
]);

const filterItem = PropTypes.shape({
	title: PropTypes.string,
	values: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool,
			PropTypes.number,
			PropTypes.shape({ title: PropTypes.string, name: PropTypes.name })
		])
	),
	key: PropTypes.string.isRequired,
	icon: PropTypes.string,
	type: PropTypes.oneOf(['button', 'select', 'date']).isRequired,
	value: filterButtonValue,
	active: PropTypes.bool
});

const pagination = PropTypes.shape({
	total: PropTypes.number.isRequired,
	current: PropTypes.number
});

export default {
	filterButtonValue,
	filterItem,
	pagination
};
